import React, { useState, useEffect } from 'react';
import * as styles from './styles.css';

export const StaticChatWidget = () => {
  const [isClosed, setIsClosed] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem('chatWidgetClosed') !== 'true') {
      setIsClosed(false);
    }
  }, []);

  const handleClose = () => {
    setIsClosed(true);
    sessionStorage.setItem('chatWidgetClosed', 'true');
  };

  return (
    <div className={styles.widgetContainer}>
      {/* Welcome Message */}
      {!isClosed && (
        <div className={styles.messageBox}>
          <div className={styles.avatarContainer}>
            <img 
              src="/img/sunny.jpeg" 
              className={styles.chatBotProfileImage}
            />
          </div>
          
          <button className={styles.closeButton} aria-label="Close chat" onClick={handleClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          <p className={styles.messageText}>
            Most questions are answered in the <a href="/#faq">FAQ</a> section or the <a href="/#howitallworks">How It All Works</a> video.
            <br /><br />
            Still have questions? Our contact details are in the page footer...
          </p>
        </div>
      )}

      {/* Floating Action Button */}
      <a href="/#faq" className={styles.fabButton} aria-label="Open FAQ">
        
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 20V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H4L0 20ZM3.15 14H18V2H2V15.125L3.15 14Z" fill="#E3E3E3"/>
        </svg>

      </a>
    </div>
  );
};

export default StaticChatWidget;
